import BlazeSlider from 'blaze-slider'
import 'blaze-slider/dist/blaze.css'

const element = document.querySelector('.element-iconlinks')

if (element) {
  const slider = element.querySelector('.blaze-slider')
  const numSlides = slider.querySelectorAll('.blaze-slide').length

  if (numSlides > 1) {
    new BlazeSlider(slider, {
      all: {
        enableAutoplay: true,
        autoplayInterval: 4000,
        transitionDuration: 300,
        slidesToShow: 2,
      },
      '(min-width: 768px)': {
        slidesToShow: 3,
      },
      '(min-width: 1024px)': {
        enableAutoplay: false,
        slidesToShow: numSlides,
      },
    })
  }
}
